var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "quoteNotifyInfo",
    staticStyle: {
      width: "700px"
    }
  }, [_c("a-table", {
    attrs: {
      loading: _vm.isTableLoading,
      columns: _vm.columns,
      dataSource: _vm.notifyList,
      pagination: false
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };